export default __webpack_public_path__ + "static/media/Menu.a6b09a30.svg";